import { render, staticRenderFns } from "./workshopBox.vue?vue&type=template&id=56ec4464&scoped=true&"
import script from "./workshopBox.vue?vue&type=script&lang=js&"
export * from "./workshopBox.vue?vue&type=script&lang=js&"
import style0 from "./workshopBox.vue?vue&type=style&index=0&id=56ec4464&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ec4464",
  null
  
)

export default component.exports